import {Card, Col, Row} from "antd";
import Widget from "./Widget";
import React from "react";


const WidgetContainer = ({ widgets }) => {
    return (
        <Card bordered={false}>
            <Row gutter={[64, 16]} justify={'start'}>
              {widgets.map((app) => (
                <Col key={app.label} span={6}>
                  <Widget config={app} />
                </Col>
              ))}
            </Row>
        </Card>
    )
}

export default WidgetContainer;